<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :filterSelects="filterSelects"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/feedback";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "user_payload_name",
      "factory",
      "organization",
      "subject",
      "status",
      "assignee",
      "contact_person",
      "updated_at",
      "created_at",
    ],
    filterSelects: [
      {
        label: "提交人",
        type: "belongsTo",
        textKey: "name",
        modelName: "user",
        placeholder: "提交人",
      },
      {
        label: "工廠",
        type: "belongsTo",
        textKey: "name",
        modelName: "factory",
        placeholder: "工廠",
      },
      {
        label: "指派人員",
        type: "belongsTo",
        textKey: "name",
        modelName: "admin",
        placeholder: "指派人員",
      },
    ],
  }),
  computed: {},
};
</script>